export default __webpack_public_path__ + "static/media/3-.c000a645.png";